import { Button, SvgIcon } from "@mui/material";

import "./style.scss";
import { ReactComponent as SummaryIcon } from "../../../assets/summary.icon.svg";
import { Provider } from "../../../common/interfaces/admin/provider.interface";
import { ModalTemplate } from "../../modal-template/modal-template.comp";

const Row = ({ label, children }: { label: string; children: React.ReactNode }) => (
    <div className="provider-properties-row">
        <span className="provider-properties-row__label">{label}</span>
        <span className="provider-properties-row__value">{children}</span>
    </div>
);

export const ProviderPropertiesModal = ({
    open,
    provider,
    handleClose
}: {
    open: boolean;
    provider: Provider;
    handleClose: () => void;
}) => {
    const url = provider.providerUrl;
    const empty = "—";

    return (
        <ModalTemplate open={open} width={654} handleClose={handleClose} ariaLabel="Properties">
            <div className="provider-properties-view">
                <div className="provider-properties-title">
                    <SvgIcon
                        className="provider-properties-title__icon"
                        component={SummaryIcon}
                        inheritViewBox
                    />
                    <span className="provider-properties-title__text">Properties</span>
                </div>
                <div className="provider-properties-list">
                    <Row label="Provider URL">
                        {url ? (
                            <a
                                className="provider-properties-row__link"
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {url}
                            </a>
                        ) : (
                            empty
                        )}
                    </Row>
                    <Row label="Provider File ID">{provider.providerFileId ?? empty}</Row>
                    <Row label="Provider Link Type">{provider.providerLinkType ?? empty}</Row>
                    <Row label="Type">{provider.name ?? empty}</Row>
                    <Row label="Email">{provider.email ?? empty}</Row>
                    <Row label="Status">{provider.status ?? empty}</Row>
                </div>
                <div className="provider-properties-action">
                    <Button variant="text" className="primary-button" onClick={handleClose}>
                        Close
                    </Button>
                </div>
            </div>
        </ModalTemplate>
    );
};
